import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GradientButton from "../Components/Button/GradientButton";
import { AssessmentResultBarChart } from "../Components/Charts/AssessmentResultBarChart";
import ShapeChart from "../Components/Charts/ShapeChart";
import { getAssessmentResultData } from "../slices/courseraSlice";
import { VerticalLine } from "../utils/icons";
import AttemptSummary from "./AttemptSummary";

function AssessmentResult() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const data = location?.state?.data;
  const userBasicInfo = useSelector((state) => state.user.userAllFormsDetails);
  const assessmentResultData = useSelector(
    (state) => state.coursera.assessmentResultData
  );

  const assessmentChartData = assessmentResultData?.FianlResults?.filter(
    (assessmentData) => {
      return assessmentData?.assessmentId === data?.assessmentId;
    }
  );
  // console.log(
  //   "🚀 ~ AssessmentResult ~ assessmentChartData:",
  //   assessmentChartData[0]?.result?.analysis?.competencies
  // );

  const profile = userBasicInfo.find((data) => data.SK === "Profile#BasicInfo");
  const dataForChart = [];
  data?.testStatus?.result?.sectionMarks.forEach((res, i) => {
    const data1 = [
      { year: res.sectionName, type: `${i}`, value: res.totalMarks },
      {
        year: res.sectionName,
        type: `${i + 1}`,
        value: (res.totalMarks * 100) / res.maxMarks,
      },
      {
        year: res.sectionName,
        type: `${i + 2}`,
        value: data?.testStatus?.result?.percentile,
      },
    ];
    dataForChart.push(...data1);
  });

  return (
    <div className="space-y-5 mb-10">
      <h1 className="text-lg font-semibold">{data?.assessmentName}</h1>
      <div className="flex justify-between items-center">
        <div className="">
          <div className="flex gap-2">
            <h1>Overall Status:</h1>
            <p className="text-orange1 font-semibold">
              {data?.testStatus?.status}
            </p>
          </div>
          <div className="flex gap-2">
            <h1>Detailed Status:</h1>
            <p className="text-orange1 font-semibold">
              {data?.testStatus?.completionMode}
            </p>
          </div>
          <div className="flex gap-2">
            <h1>Test Finish Time:</h1>
            <p className="text-orange1 font-semibold">
              {data?.testStatus?.endTime}
            </p>
          </div>
        </div>
        <GradientButton>
          <a href={data?.testStatus?.pdfReport} target="_">
            Download Result
          </a>
        </GradientButton>
      </div>
      <div>
        <div className="flex items-center gap-5">
          {/* <img
            className="w-[80px] h-[80px] rounded-xl"
            src="https://wallpapers.com/images/featured/cool-profile-picture-87h46gcobjl5e4xu.jpg"
            alt="img"
          /> */}
          <Avatar shape="square" size={80} icon={<UserOutlined />} />
          <div>
            <h1>{profile?.Name.split(" ")[0]}</h1>
            <p>{profile?.Email}</p>
            <p>Test-Taker ID: - {data?.assessmentId}</p>
          </div>
          <VerticalLine />
          <div>
            <table className="text-left">
              <tr>
                <th>Last Name:</th>
                <td>{profile?.Name.split(" ")[1]}</td>
              </tr>
              <tr>
                <th>Gender Identity:</th>
                <td>
                  {data?.registrationDetails?.["Gender Identity"] || "Male"}
                </td>
              </tr>
              <tr>
                <th>Country of Residence:</th>
                <td>{profile?.CountryOfResidency}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div>
        <h1 className="mb-5 font-semibold text-lg">Overall Summary</h1>
        <div className="flex justify-evenly">
          <div className="flex items-center gap-3 bg-MeduimGrey py-2 px-10 rounded-lg">
            <h1 className="text-orange1 text-4xl font-bold">
              {Math.round(data?.testStatus?.result?.totalMarks)}
            </h1>
            <p>
              Marks Scored <br /> out of {data?.testStatus?.result?.maxMarks}
            </p>
          </div>
          <div className="flex items-center gap-3 bg-MeduimGrey py-2 px-10 rounded-lg">
            <h1 className="text-orange1 text-4xl font-bold">
              {Math.round(
                (data?.testStatus?.result?.totalCorrectAnswers /
                  data?.testStatus?.result?.totalQuestion) *
                  100
              )}
              %
            </h1>
            <p>
              {data?.testStatus?.result?.percentile} Percentile <br /> out of{" "}
              {data?.testStatus?.result?.totalQuestion}
            </p>
          </div>
          <div className="flex items-center gap-3 bg-MeduimGrey py-2 px-10 rounded-lg">
            <h1 className="text-orange1 text-4xl font-bold">
              {Math.floor(data?.testStatus?.result?.attemptTime)}s
            </h1>
            <p>
              Time taken <br /> of {data?.assessmentDuration} min
            </p>
          </div>
        </div>
      </div>
      <ShapeChart data={dataForChart} />
      <AssessmentResultBarChart
        title="Analysis"
        data={
          assessmentChartData &&
          assessmentChartData[0]?.result?.analysis?.competencies
        }
      />
      <AttemptSummary data={location?.state?.data} />
      {/* <div className="space-y-5">
        <h1>Section-Wise Details</h1>
        <p>Section #1</p>
        <ShapeChart />
      </div>
      <AttemptSummary /> */}
    </div>
  );
}

export default AssessmentResult;
